/** Superfície de campo somente leitura — fundo levemente distinto, texto com contraste pleno. */
export const readOnlyFieldSurfaceClass =
  "rounded-xl border border-border-1 bg-background-2 shadow-sm text-foreground pointer-events-none select-none";

/** Classes extras para `InputBase` read-only/disabled (sobrescreve `text-text-disabled` do DS). */
export const readOnlyInputClass = `${readOnlyFieldSurfaceClass} text-foreground! cursor-default`;

interface ReadOnlyFieldProps {
  label: string;
  value?: string;
}

export const ReadOnlyField = ({ label, value }: ReadOnlyFieldProps) => (
  <div>
    <p className="mb-1">{label}</p>
    <p className={`flex w-full px-4 py-2 text-sm ${readOnlyFieldSurfaceClass}`}>
      {value ?? ""}
    </p>
  </div>
);
